import React from 'react';
import { TextInput, TextInputProps } from 'react-admin';
import { FormWithRedirect } from 'react-admin';
import { useTextValidation } from '../hooks/useTextValidation';

interface TextOnlyInputProps extends Omit<TextInputProps, 'onChange' | 'onPaste'> {
  form: React.ComponentProps<typeof FormWithRedirect>['form'];
}

const TextOnlyInput: React.FC<TextOnlyInputProps> = ({
  form,
  source,
  helperText,
  ...props
}) => {
  const { sanitizeText, showWarning, warningMessage } = useTextValidation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const sanitized = sanitizeText(e.target.value || '', 'escribir');
    form.change(source as string, sanitized);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    e.preventDefault();
    const paste = e.clipboardData?.getData('text') || '';
    const sanitized = sanitizeText(paste, 'pegar');
    const current = form.getState().values?.[source as string] || '';
    form.change(source as string, `${current}${sanitized}`);
  };

  const getHelperText = (): string => {
    if (showWarning) return warningMessage;
    return helperText as string || "Solo se permiten letras y espacios";
  };

  return (
    <TextInput
      {...props}
      source={source}
      onChange={handleChange}
      onPaste={handlePaste}
      helperText={getHelperText()}
    />
  );
};

export default TextOnlyInput;